import { types } from 'mobx-state-tree';

import Contact from '../Contact';

import Actions from './actions';
import Views from './views';

const OnDemand = types.model({
  emailSubscription: types.maybeNull(types.boolean),
  isLoaded: types.optional(types.boolean, false),
  isFetchingContacts: types.optional(types.boolean, false),
  isContactsFetched: types.optional(types.boolean, false),
  onDemandContacts: types.map(Contact),
  numberOfDaysFilter: types.optional(types.number, 90),
  numberOfOnDemandContacts: types.optional(types.number, 0),
  selectedContactId: types.optional(types.string, ''),
  requestId: types.optional(types.string, ''),
  isFetchContactsError: types.optional(types.boolean, false),
  numberOfNewOnDemandContacts: types.optional(types.number, 0),
  shouldReFetchContactsAfterShow: types.optional(types.boolean, false),
  isOnDemandContactShown: types.optional(types.boolean, false),
}).actions(Actions).views(Views);

export default OnDemand;
